<template>
  <div>
    <v-switch v-model="reloadAfterChanges" color="primary" label="Neuladen nach anpassung"></v-switch>
    <v-card-subtitle class="pt-0">
      Wenn das automatische neuladen deaktiviert ist, kann es zu Anzeigefehler kommen. Bitte dann über den Knopf neu laden.
      <v-btn color="primary" @click="$emit('fetchEntries')">Neu laden</v-btn>
    </v-card-subtitle>
    <v-row v-if="timeEntryView.canSelfCheckin">
      <v-col cols="12">
        <v-select v-model="selectedFirma" :items="['Firma 1', 'Firma 2']" label="Firma filtern" class="mx-5" dense outlined></v-select>
        <v-btn color="success" class="ml-2" @click="exportToExcel">
          <v-icon left>mdi-file-excel</v-icon>
          Monats-Export (Zwei Firmen)
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="!editTimeEntry">
      <v-col cols="12">
        <v-card-text class="h6 pb-0" style="letter-spacing: 0.9px"><strong>Zeiterfassung</strong></v-card-text>
        <v-data-table
          :items-per-page="40"
          no-data-text="Keine Anwesenheits Einträge gefunden"
          :headers="tableHeaders"
          hide-default-footer
          :expanded.sync="expanded"
          :item-key="'date'"
          :show-expand="
            office ||
            !timeEntryView.timeTrackerMonths ||
            !timeEntryView.timeTrackerMonths.find((ttm) => ttm.month === $moment(this.month).format('YYYY-MM')) ||
            (timeEntryView.timeTrackerMonths.find((ttm) => ttm.month === $moment(this.month).format('YYYY-MM')) &&
              timeEntryView.timeTrackerMonths.find((ttm) => ttm.month === $moment(this.month).format('YYYY-MM')).state !== 'submitted')
          "
          :key="keyey"
          :single-expand="true"
          :items="tableItems">
          <template v-slot:item.startTime="{ item }">
            <span>
              {{ getStartTime(item.realDate, item.disableCorrection) }}
            </span>
          </template>
          <template v-slot:item.endTime="{ item }">
            <span>
              {{ getEndTime(item.realDate, item.disableCorrection) }}
            </span>
          </template>
          <template v-slot:item.duration="{ item }">
            <span>
              {{ getDurationForDay(item.realDate, item.disableCorrection).formattedTime }}
            </span>
          </template>
          <template v-slot:item.workTime="{ item }">
            <span>
              {{ getWorkDuration(item.realDate, item.disableCorrection).formattedTime }}
            </span>
          </template>
          <template v-slot:item.absence="{ item }">
            <v-tooltip bottom v-if="item.absence.note" open-delay="200" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" style="cursor: help; border-bottom: 1px dotted rgba(255, 255, 255, 0.3)">
                  {{ item.absence.formattedTime }}
                </span>
              </template>
              <span>{{ item.absence.note }}</span>
            </v-tooltip>
            <span v-else>
              {{ item.absence.formattedTime }}
            </span>
          </template>
          <template v-slot:item.pause="{ item }">
            <v-chip
              :color="!checkToShortPause(item) ? 'red' : 'grey'"
              @click="
                () => {
                  if (item.correction !== '-') return hasCorrectionsOpenAlert()

                  if (!isMonthLocked && !checkToShortPause(item)) fixTimeDialogOptionPicker = true
                  fixTimeDialogItem = JSON.parse(JSON.stringify(item))
                }
              ">
              {{ getPauseDuration(item.realDate, item.disableCorrection).formattedTime }}
            </v-chip>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="tableHeaders.length">
              <v-data-table
                hide-default-footer
                :items-per-page="40"
                no-data-text="Keine Anwesenheits Einträge gefunden"
                :headers="innerTableHeaders"
                :expanded.sync="expanded"
                :items="tableItemsForItem(item.realDate, item.disableCorrection)">
                <template v-slot:item.type="{ item }">
                  <v-tooltip bottom v-if="item.note" open-delay="200">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip :color="mappedColors[item.type]" v-bind="attrs" v-on="on">
                        {{ item.absenceReason ? mappedEntryTypes[item.absenceReason] : mappedEntryTypes[item.type] }}
                      </v-chip>
                    </template>
                    <span>{{ item.note }}</span>
                  </v-tooltip>
                  <v-chip v-else :color="mappedColors[item.type]">
                    {{ item.absenceReason ? mappedEntryTypes[item.absenceReason] : mappedEntryTypes[item.type] }}
                  </v-chip>
                </template>

                <template v-slot:item.correction="{ item }">
                  <div v-if="timeEntryView.canSelfCheckin && !item.absenceReason && item.type !== 'holiday' && !isMonthLocked">
                    <v-btn icon @click="changeCanSelfCheckinNoAdmin(item)">
                      <v-icon color="blue">mdi-pen</v-icon>
                    </v-btn>
                  </div>
                  <div v-else>
                    <v-btn icon v-if="item.type === 'sick' && !isMonthLocked" @click="deleteSickEntry(item)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-chip
                      hover
                      @click="item.correction !== 'Versteckt' && !isMonthLocked && showEmployeeCorretionDialog(item)"
                      v-if="item.correction !== '-'"
                      :color="
                        item.correction === 'Bearbeitet'
                          ? 'blue'
                          : item.correction === 'Neu'
                          ? 'success'
                          : item.correction === 'Versteckt'
                          ? 'grey'
                          : item.correction === 'Akzeptiert'
                          ? 'success'
                          : 'error'
                      ">
                      <span>{{ item.correction }}</span>
                    </v-chip>
                  </div>
                </template>
              </v-data-table>
              <v-textarea
                disabled
                color="white"
                dark
                v-if="timeEntryView.timeTrackerDailyNotes && timeEntryView.timeTrackerDailyNotes.find((noteEntry) => noteEntry.day === item.realDate)"
                :value="timeEntryView.timeTrackerDailyNotes.find((noteEntry) => noteEntry.day === item.realDate).note"></v-textarea>
            </td>
          </template>
          <template v-slot:item.correction="{ item }">
            <div v-if="timeEntryView.canSelfCheckin && !isMonthLocked">
              <v-btn icon @click="changeCanSelfCheckinNoAdmin(item, true)">
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </div>
            <v-chip
              v-if="item.correction !== '-'"
              :hover="!isMonthLocked"
              @click="
                if (!isMonthLocked) {
                  item.disableCorrection = !item.disableCorrection
                  updateIt()
                }
              "
              :color="item.disableCorrection ? 'grey' : 'orange'">
              <span>{{ item.disableCorrection ? "versteckt" : item.correction }}</span>
            </v-chip>
          </template>
        </v-data-table>
        <v-card-title>Monats Informationen</v-card-title>
        <v-row v-if="timeEntryView.overTime">
          <v-col cols="1"></v-col>
          <v-col cols="auto">Überstunden (Stand letzte abgeschlossene Zeiterfassung)</v-col>
          <v-col cols="auto">{{ timeEntryView.overTime }} Stunden</v-col>
        </v-row>
        <v-row v-if="currentMonthPercentage && !timeEntryView.noFixPercentage">
          <v-col cols="1"></v-col>
          <v-col cols="auto">Sollstunden diesen Monat</v-col>

          <v-col cols="auto">
            {{
              Math.round((calcBusinessDays - vacationDaysForMonth(studio).length) * ((8.4 * currentMonthPercentage) / 100) * 1000) / 1000 +
              " Stunden (" +
              currentMonthPercentage +
              "%)"
            }}
            <v-chip v-if="isPartialMonthEntry" color="info" x-small class="ml-2" outlined>
              Eintritt: {{ $moment(timeEntryView.entryDate).format("DD.MM.") }}
            </v-chip>
            <v-chip v-if="isPartialMonthExit" color="warning" x-small class="ml-2" outlined>
              Austritt: {{ $moment(timeEntryView.exitDate).format("DD.MM.") }}
            </v-chip>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="1"></v-col>
          <v-col cols="auto">Arbeitstage diesen Monat</v-col>

          <v-col cols="auto">
            {{ calcBusinessDays - vacationDaysForMonth(studio).length }}
            <span class="ml-2" v-if="vacationDaysForMonth(studio).length">
              ( {{ calcBusinessDays }} - {{ vacationDaysForMonth(studio).length }} Feiertag/e )
              <v-chip class="ml-1" small :key="'vacationday' + index" v-for="(vacationDay, index) of vacationDaysForMonth(studio)">{{
                vacationDay.title
              }}</v-chip>
            </span>
            <v-chip v-if="isPartialMonthEntry" color="info" small class="ml-2" outlined>
              <v-icon left small>mdi-information</v-icon>
              Reduziert (Eintritt: {{ $moment(timeEntryView.entryDate).format("DD.MM.YYYY") }})
            </v-chip>
            <v-chip v-if="isPartialMonthExit" color="warning" small class="ml-2" outlined>
              <v-icon left small>mdi-information</v-icon>
              Reduziert (Austritt: {{ $moment(timeEntryView.exitDate).format("DD.MM.YYYY") }})
            </v-chip>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="1"></v-col>
          <v-col cols="auto">Geleistete Stunden</v-col>

          <v-col cols="auto">{{ getTotalDuration.formattedTime }}</v-col>
        </v-row>
        <v-row v-if="currentMonthPercentage && !timeEntryView.noFixPercentage">
          <v-col cols="1"></v-col>
          <v-col cols="auto">Differenz (in Stunden)</v-col>
          <v-col cols="auto">
            {{
              Math.round(
                (getTotalDuration.formattedTime - (calcBusinessDays - vacationDaysForMonth(studio).length) * ((8.4 * currentMonthPercentage) / 100)) *
                  1000,
              ) / 1000
            }}
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              @blur="updateNote()"
              v-if="(!submissionState && !office) || (submissionState && submissionState.state === 'onlyNotes')"
              label="Notiz"
              rows="2"
              auto-grow
              v-model="timeTrackerMonth.note"></v-textarea>
            <v-textarea
              v-if="(submissionState && submissionState.state === 'submitted') || office"
              label="Notiz"
              rows="2"
              auto-grow
              @blur="updateNote()"
              :disabled="!office"
              v-model="submissionState.note"></v-textarea>
            <v-textarea
              v-if="submissionState && submissionState.state === 'rejected' && !office"
              label="Notiz"
              rows="2"
              auto-grow
              @blur="updateNote()"
              v-model="submissionState.note"></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-if="submissionState"
              :label="submissionState ? 'Status' : ''"
              :value="
                submissionState && submissionState.state === 'submitted'
                  ? 'eingereicht'
                  : submissionState.state === 'rejected'
                  ? 'abgelehnt'
                  : submissionState.state === 'accepted'
                  ? 'abgeschlossen'
                  : 'Notiz eingetragen (noch nicht eingereicht)'
              "
              placeholder="(Status) Noch nicht eingereicht"
              disabled></v-text-field>
          </v-col>
          <v-col cols="12" class="justify-content-Center">
            <v-btn
              v-if="
                (submissionState && submissionState.state === 'rejected' && !office) ||
                (!submissionState && !office) ||
                (submissionState && submissionState.state === 'onlyNotes')
              "
              @click="submitTimeTrackerMonth()"
              color="success">
              Einreichen
            </v-btn>
          </v-col>
          <v-col cols="12" class="justify-content-Center">
            <v-btn
              class="mx-3"
              v-if="submissionState && submissionState.state === 'submitted' && office"
              @click="submitTimeTrackerMonth('rejected')"
              color="error">
              Ablehnen
            </v-btn>
            <v-btn
              v-if="submissionState && submissionState.state === 'submitted' && office"
              @click="submitTimeTrackerMonth('accepted')"
              color="success">
              Akzeptieren
            </v-btn>
          </v-col>
          <v-col cols="12" class="d-flex justify-center mt-2">
            <v-btn v-if="office" @click="exportExcelDialog = true" color="info" outlined class="mx-3">
              <v-icon left>mdi-file-excel</v-icon>
              Abrechnung exportieren (Excel)
            </v-btn>
          </v-col>
        </v-row>
        <v-dialog v-model="showCorrectionDialog">
          <v-card v-if="correctedItem">
            <v-card-title style="place-content: center"> Korrektur für den {{ $moment(correctedItem.realDate).format("DD.MM.YYYY") }} </v-card-title>
            <v-row no-gutters>
              <v-col
                cols="6"
                v-if="correctedItem.beforeCorrectionTime || correctedItem.beforeCorrectedTime"
                style="border-right: 3px solid grey"
                class="flex-row justify-content-center">
                <v-card-title class="error--text justify-text-center font-weight-bold" style="place-content: center"> Vor Korrektur </v-card-title>
                <v-card-title style="place-content: center">
                  {{ correctedItem.beforeCorrectionTime || correctedItem.beforeCorrectedTime + " Uhr" }}
                </v-card-title>
                <v-card-title style="place-content: center">
                  {{ correctedItem.beforeCorrectionType || correctedItem.beforeCorrectedType }}
                </v-card-title>
                <v-card-actions
                  v-if="correctedItem.type === 'checkoutCorrectionOpen' || correctedItem.type === 'checkinCorrectionOpen'"
                  class="justify-content-center">
                  <v-btn @click="rejectCorrection(correctedItem)" color="error">Ablehnen</v-btn>
                </v-card-actions>
              </v-col>
              <v-col
                :cols="correctedItem.beforeCorrectionTime || correctedItem.beforeCorrectedTime ? '6' : '12'"
                class="flex-row justify-content-center">
                <v-card-title
                  :class="{ 'error--text': correctedItem.delete === true }"
                  class="primary--text justify-text-center font-weight-bold"
                  style="place-content: center">
                  {{
                    correctedItem.beforeCorrectionTime
                      ? "Nachher"
                      : correctedItem.beforeCorrectedTime
                      ? "Aktuell"
                      : correctedItem.correction === "Abgelehnt"
                      ? "Abgelehnter Antrag"
                      : correctedItem.delete
                      ? "Gelöschter Eintrag"
                      : "Neuer Eintrag"
                  }}
                </v-card-title>
                <v-card-title style="place-content: center">
                  {{ correctedItem.time + " Uhr" }}
                </v-card-title>
                <v-card-title style="place-content: center">
                  {{ correctedItem.type.includes("checkout") ? "checkout" : "checkin" }}
                </v-card-title>
                <v-card-actions
                  v-if="
                    correctedItem.beforeCorrectionTime ||
                    correctedItem.type === 'checkoutCorrectionOpen' ||
                    correctedItem.type === 'checkinCorrectionOpen' ||
                    correctedItem.delete
                  "
                  class="justify-content-center">
                  <v-btn
                    v-if="!correctedItem.beforeCorrectionTime && !correctedItem.beforeCorrectedTime"
                    @click="rejectCorrection(correctedItem)"
                    color="error">
                    Ablehnen
                  </v-btn>

                  <v-btn @click="acceptCorrection(correctedItem)" color="primary">Akzeptieren</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-card>
          <v-card v-else>Fehler beim anzeigen bitte neu laden.</v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <office-time-tracker-entry-infos
          :employeeId="timeEntryView.employee._id"
          @fetchEntries="timeTrackerInfosUpdated"
          :entries="editTimeEntry"></office-time-tracker-entry-infos>
      </v-col>
      <v-col cols="12" class="d-flex justify-center">
        <v-btn @click="editTimeEntry = null">Zurück</v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="changeCanSelfCheckinNoAdminDialog" persistent max-width="800px">
      <v-card v-if="changeCanSelfCheckinNoAdminDialog">
        <v-card-title>Eintrag anpassen</v-card-title>
        <v-card-text>
          <v-row no-gutters>
            <v-time-picker full-width v-model="selfCheckinEntryEdit.time" format="24hr"></v-time-picker>
          </v-row>
          <v-row no-gutters>
            <v-select
              v-model="selfCheckinEntryEdit.type"
              :items="[
                { text: 'Check-In', value: 'checkin' },
                { text: 'Check-Out', value: 'checkout' },
                { text: 'Pause', value: 'pause' },
                { text: 'Pause Fertig', value: 'pauseend' },
              ]"
              label="Typ"></v-select>
          </v-row>
          <v-row class="justify-content-center">
            <v-btn color="primary" @click="saveSelfCheckinEntryEdit()">Zeit speichern</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="fixTimeDialogOptionPicker" max-width="800px">
      <v-card dark>
        <v-card-title>Wie willst du die Pause anpassen?</v-card-title>
        <v-row class="justify-space-around">
          <v-col cols="6">
            <v-card class="d-flex flex-column px-3">
              <v-card-subtitle class="font-weight-bold px-0">Pause verlängern</v-card-subtitle>
              <span>Die Pause wird verlängert und von der Arbeitszeit abgezogen</span>
              <v-card-actions class="justify-content-center">
                <v-btn x-large color="primary" @click="fixToShortTime(fixTimeDialogItem, 'extendPause')" icon>
                  <v-icon>mdi-check-circle</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card class="d-flex flex-column px-3">
              <v-card-subtitle class="font-weight-bold px-0"> Pause verlängern & Arbeitszeit anpassen </v-card-subtitle>
              <span>Die Pause wird verlängert die Arbeitszeit bleibt die gleiche.</span>
              <v-card-actions class="justify-content-center">
                <v-btn x-large color="primary" @click="fixToShortTime(fixTimeDialogItem, 'extendWorktime')" icon>
                  <v-icon>mdi-check-circle</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="fixTimeDialog" max-width="800px">
      <v-card dark v-if="preSavedAttendances">
        <v-card-title>Soll die Pausenzeit automatisch angepasst werden?</v-card-title>
        <v-row>
          <v-col cols="5">
            <div v-for="(att, key) in preSavedAttendances.old" class="pa-2" :key="'att' + key">
              <v-chip :color="mappedColors[att.type]">
                {{ mappedEntryTypes[att.type] }}
              </v-chip>
              {{ att.time }}
            </div>
          </v-col>
          <v-col cols="2" style="align-self: center">
            <v-icon class="my-auto" x-large color="primary">mdi-arrow-right-thin</v-icon>
          </v-col>
          <v-col cols="5">
            <div v-for="(att, key) in preSavedAttendances.new" class="pa-2" :key="'att' + key">
              <v-chip :color="mappedColors[att.type]">
                {{ mappedEntryTypes[att.type] }}
              </v-chip>
              {{ att.time }}
            </div>
          </v-col>
        </v-row>
        <v-card-actions class="justify-content-center">
          <v-btn color="primary" @click="savePreSavedAttendances">Akzeptieren</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showSubmitOfficeDialog" max-width="500" overlay-opacity="0.90" overlay-color="#050505">
      <div style="position: relative; padding-top: 45px">
        <div class="d-flex justify-center" style="position: absolute; top: 0; left: 0; right: 0; z-index: 2">
          <v-avatar size="90" class="elevation-10 shadow-glow icon-ring" style="background: linear-gradient(135deg, #00963f 0%, #005c27 100%)">
            <v-icon x-large color="white">mdi-shield-check-outline</v-icon>
          </v-avatar>
        </div>

        <v-card class="rounded-xl glass-card text-center pb-6 pt-10 px-6 overflow-visible" elevation="24">
          <div
            style="
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              height: 120px;
              background: linear-gradient(to bottom, rgba(0, 150, 63, 0.15) 0%, transparent 100%);
              z-index: 0;
              border-radius: 24px 24px 0 0;
            "></div>

          <div style="position: relative; z-index: 1">
            <h3 class="text-h5 font-weight-bold white--text mb-1 mt-4">Monatsabschluss bestätigen</h3>
            <div class="text-subtitle-2 grey--text mb-6">{{ timeEntryView.fullName }}</div>

            <v-sheet color="rgba(255,255,255,0.05)" class="rounded-lg pa-4 mb-6 border-light">
              <v-row dense>
                <v-col :cols="timeEntryView.noFixPercentage ? '12' : '6'" class="text-left">
                  <div class="text-caption grey--text">Geleistet</div>
                  <div class="font-weight-bold white--text text-h6">{{ submitOfficeData.duration }} h</div>
                </v-col>
                <v-col v-if="!timeEntryView.noFixPercentage" cols="6" class="text-right">
                  <div class="text-caption grey--text">Differenz</div>
                  <div class="font-weight-bold text-h6" :class="parseFloat(submitOfficeData.difference) >= 0 ? 'success--text' : 'error--text'">
                    {{ submitOfficeData.difference }} h
                  </div>
                </v-col>
                <v-col cols="12" class="mt-2 pt-2" style="border-top: 1px solid rgba(255, 255, 255, 0.1)">
                  <div class="d-flex justify-space-between align-center">
                    <span class="text-caption grey--text">Überstunden Saldo (Neu)</span>
                    <span class="font-weight-bold white--text">{{ submitOfficeData.newOvertime }} h</span>
                  </div>
                </v-col>
              </v-row>
            </v-sheet>

            <v-alert color="rgba(255, 152, 0, 0.15)" class="rounded-lg text-left mb-6" style="border: 1px solid rgba(255, 152, 0, 0.3)">
              <div class="d-flex align-start">
                <v-icon color="orange" small class="mt-1 mr-3">mdi-alert-decagram-outline</v-icon>
                <div class="caption grey--text text--lighten-1" style="line-height: 1.4">
                  Mit der Einreichung der Stundenübersicht des Mitarbeiters, bestätigt der Vorgesetzte diese
                  <strong class="white--text">kontrolliert zu haben</strong> und bestätigt deren <strong class="white--text">Richtigkeit</strong>.
                </div>
              </div>
            </v-alert>

            <v-row dense>
              <v-col cols="5">
                <v-btn block large text color="grey" class="rounded-lg" @click="showSubmitOfficeDialog = false"> Abbrechen </v-btn>
              </v-col>
              <v-col cols="7">
                <v-btn
                  block
                  large
                  color="#00963f"
                  class="rounded-lg white--text shadow-glow btn-hover-scale"
                  @click="confirmOfficeSubmission"
                  :loading="submitLoading">
                  <v-icon left small>mdi-check-all</v-icon>
                  Bestätigen
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </div>
    </v-dialog>
    <!-- EXCEL EXPORT DIALOG -->
    <v-dialog v-model="exportExcelDialog" max-width="500">
      <v-card color="#1e1e1e" dark>
        <v-card-title>Abrechnung exportieren</v-card-title>
        <v-card-text>
          <p>Wähle den Zeitraum für den Excel-Export aus.</p>
          <v-row>
            <v-col cols="6">
              <v-menu v-model="menuExportStart" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="exportStartMonth" label="Von (Monat)" readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="exportStartMonth" type="month" @input="menuExportStart = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-menu v-model="menuExportEnd" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="exportEndMonth" label="Bis (Monat)" readonly v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="exportEndMonth" type="month" @input="menuExportEnd = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text color="grey" @click="exportExcelDialog = false">Abbrechen</v-btn>
          <v-btn color="success" :loading="exportingExcel" @click="generateAndDownloadExcel">
            <v-icon left>mdi-download</v-icon> Herunterladen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import officeTimeTrackerEntryInfos from "./OfficeTimeTrackerEntryInfos.vue"
import api from "@/api"
import { mapState } from "vuex"

export default {
  name: "OfficeTimeTrackerView",
  props: {
    office: {
      default: false,
      type: Boolean,
    },
    month: {
      required: true,
    },
    timeEntryView: {
      type: Object,
      required: true,
    },
    studio: {
      required: true,
    },
  },
  components: { officeTimeTrackerEntryInfos },
  data() {
    return {
      holidaysData: [],
      notes: [],
      calendarType: "month",
      showSubmitOfficeDialog: false,
      submitLoading: false,
      submitOfficeData: {
        duration: 0,
        difference: 0,
        overtimeBefore: 0,
        newOvertime: 0,
        targetState: "submitted",
      },
      selectedFirma: "Firma 1", // HINZUGEFÜGT: Standardfilter

      fixTimeDialogItem: null,
      fixTimeDialogOptionPicker: false,
      fixTimeDialog: false,
      preSavedAttendances: null,
      reloadAfterChanges: true,
      timeTrackerMonth: {
        note: "",
      },
      correctedItem: null,
      showCorrectionDialog: false,
      mapHolidayStatus: {
        open: "Offen",
        accepted: "Akzeptiert",
        denied: "Abgelehnt",
      },
      exportExcelDialog: false,
      menuExportStart: false,
      menuExportEnd: false,
      exportStartMonth: this.$moment(this.month).format("YYYY-MM"),
      exportEndMonth: this.$moment(this.month).format("YYYY-MM"),
      exportingExcel: false,
      mappedEntryTypes: {
        technicCheckin: "Checkin Badge",
        technicCheckout: "Checkout Badge",
        sick: "Krank",
        school: "Schule",
        pregnancy: "Schwangerschaft",
        other: "Anderes",
        military: "Militär",
        holiday: "Ferien",
        holidayFix: "FERIEN OHNE PENSUM ABZUG",
        checkin: "Check-In",
        checkout: "Check-Out",
        pause: "Pause",
        pauseend: "Pause fertig",
        error: "Fehler (Checkin ohne Checkout)",
        error1: "Fehler (2 Check-Ins hintereinander)",
        error2: "Fehler (2 Check-Outs hintereinander)",
        error3: "Fehler (Checkout ohne Checkin)",
        deleteCorrectionOpen: "Löschen (Korrektur offen)",
        checkinCorrectionOpen: "Check-In (Korrektur offen)",
        checkinCorrectionDenied: "Check-In (Korrektur abgelehnt)",
        checkinCorrectionApproved: "Check-In (Korrektur genehmigt)",
        checkoutCorrectionOpen: "Check-Out (Korrektur offen)",
        checkoutCorrectionDenied: "Check-Out (Korrektur abgelehnt)",
        checkoutCorrectionApproved: "Check-Out (Korrektur genehmigt)",
      },
      keyey: 0,
      mappedColors: {
        technicCheckin: "green",
        technicCheckout: "red",
        sick: "orange",
        holiday: "orange",
        checkin: "success",
        checkout: "grey",
        pause: "blue",
        pauseend: "blue",
        error: "red",
        error1: "red",
        error2: "red",
        error3: "red",
        deleteCorrectionOpen: "red",
        checkinCorrectionOpen: "orange",
        checkinCorrectionDenied: "red",
        checkinCorrectionApproved: "success",
        checkoutCorrectionOpen: "orange",
        checkoutCorrectionDenied: "red",
        checkoutCorrectionApproved: "success",
      },
      tableHeaders: [
        { text: "Datum", value: "date" },
        { text: "Startzeit", value: "startTime" },
        { text: "Endzeit", value: "endTime" },
        { text: "Abwesend", value: "absence" },
        { text: "Dauer", value: "duration" },
        { text: "Pause", value: "pause" },
        { text: "Gearbeitet", value: "workTime" },
        { text: "Korrektur", value: "correction" },
        { text: "", value: "data-table-expand" },
      ],
      innerTableHeaders: [
        { text: "Uhrzeit", value: "time", sortable: false },
        { text: "Typ", value: "type", sortable: false },
        { text: "Studio", value: "studio", sortable: false },
        { text: "Dauer (Abwesenheit)", value: "duration", sortable: false },
        { text: "Korrektur", value: "correction", sortable: false },
        // { text: 'Aktion', value: 'actions', sortable: false },
      ],
      expanded: [],
      editTimeEntry: null,
      selfCheckinEntryEdit: null,
      changeCanSelfCheckinNoAdminDialog: false,
    }
  },
  async created() {
    if (!this.holidaysData.length && api.fetchHolidays) {
      try {
        this.holidaysData = await api.fetchHolidays()
      } catch (e) {
        console.error("Error fetching holidays", e)
      }
    }
  },
  watch: {
    submissionState: {
      immediate: true,
      handler(val) {
        if (val && val.note !== undefined) {
          this.timeTrackerMonth.note = val.note
        }
      },
    },
  },
  computed: {
    ...mapState("studioStore", ["storeStudios"]),
    filteredAttendance() {
      if (!this.timeEntryView.attendance || !this.timeEntryView.canSelfCheckin) {
        return this.timeEntryView.attendance
      }

      const filtered = {}
      for (const date in this.timeEntryView.attendance) {
        const entriesForDate = this.timeEntryView.attendance[date]
        if (Array.isArray(entriesForDate)) {
          filtered[date] = entriesForDate.filter((entry) => {
            const company = entry.company || "Firma 1"
            return company === this.selectedFirma
          })
        }
      }
      return filtered
    },

    submissionState() {
      if (!this.timeEntryView || !this.timeEntryView.timeTrackerMonths) return null
      return this.timeEntryView.timeTrackerMonths.find((ttm) => ttm.month === this.$moment(this.month).format("YYYY-MM")) || null
    },
    currentMonthPercentage() {
      if (!this.timeEntryView) return 0
      let targetFormat = this.$moment(this.month).format("YYYY-MM")

      // pensumHistory is inside studio[], find matching studio entry
      let studioId = this.studio && this.studio._id ? this.studio._id : this.studio
      let studioEntry = (this.timeEntryView.studio || []).find((s) => s._id && s._id.toString() === (studioId ? studioId.toString() : ""))
      // Fallback: if no studioId match, try first studio entry
      if (!studioEntry && this.timeEntryView.studio && this.timeEntryView.studio.length) {
        studioEntry = this.timeEntryView.studio[0]
      }

      let history = (studioEntry && studioEntry.pensumHistory) || []
      let sortedHistory = history.slice().sort((a, b) => b.validFrom.localeCompare(a.validFrom))
      let applicable = sortedHistory.find((h) => h.validFrom <= targetFormat)
      if (applicable) return applicable.percentage
      // Fallback to base percentage of that studio entry or top-level
      return (studioEntry && studioEntry.percentage) || this.timeEntryView.percentage || 0
    },
    calcBusinessDays() {
      var day = this.$moment(this.month).startOf("month")
      var businessDays = 0

      let entryDate = this.timeEntryView.entryDate ? this.$moment(this.timeEntryView.entryDate, "YYYY-MM-DD") : null
      let exitDate = this.timeEntryView.exitDate ? this.$moment(this.timeEntryView.exitDate, "YYYY-MM-DD") : null

      while (day.isSameOrBefore(this.$moment(this.month).endOf("month"), "day")) {
        let isAfterEntry = !entryDate || day.isSameOrAfter(entryDate, "day")
        let isBeforeExit = !exitDate || day.isSameOrBefore(exitDate, "day")

        if (day.day() != 0 && day.day() != 6 && isAfterEntry && isBeforeExit) {
          businessDays++
        }
        day.add(1, "d")
      }
      return businessDays
    },
    isPartialMonthEntry() {
      if (!this.timeEntryView || !this.timeEntryView.entryDate) return false
      let entry = this.$moment(this.timeEntryView.entryDate)
      let monthStart = this.$moment(this.month).startOf("month")
      let monthEnd = this.$moment(this.month).endOf("month")
      return entry.isAfter(monthStart) && entry.isSameOrBefore(monthEnd)
    },
    isPartialMonthExit() {
      if (!this.timeEntryView || !this.timeEntryView.exitDate) return false
      let exit = this.$moment(this.timeEntryView.exitDate)
      let monthStart = this.$moment(this.month).startOf("month")
      let monthEnd = this.$moment(this.month).endOf("month")
      return exit.isBefore(monthEnd) && exit.isSameOrAfter(monthStart)
    },
    tableItems() {
      let items = []
      let includesCorrection = false
      if (!this.filteredAttendance) return items
      for (const date of Object.keys(this.filteredAttendance).filter((key) => key !== "email" && key !== "_id")) {
        includesCorrection = this.timeEntryView.attendance[date].find((entry) => entry.correction && entry.correction === "open")
        items.push({
          realDate: date,
          date: this.$moment(date).format("DD.MM."),
          startTime: "",
          endTime: "",
          absence: this.getAbsenceDuration(this.timeEntryView.attendance[date], date),
          workTime: "",
          pause: "",
          duration: "",
          correction: includesCorrection ? "Offen" : "-",
        })
      }
      return items
    },
    getTotalDuration() {
      return this.getHolidayDurationSum
    },
    isMonthLocked() {
      // Wenn es die Admin-Ansicht (office) ist, ist es nie gesperrt für den Admin
      if (this.office) return false

      // Ansonsten (Centerleiter) sperren wir, wenn der Monat 'submitted' oder 'accepted' ist.
      if (this.submissionState && (this.submissionState.state === "submitted" || this.submissionState.state === "accepted")) {
        return true
      }
      return false
    },
    getHolidayDurationSum() {
      let totalMinutes = 0

      if (!this.filteredAttendance) return { formattedTime: 0, totalMinutes: 0 }
      Object.keys(this.filteredAttendance).forEach((date) => {
        totalMinutes += this.getWorkDuration(date).totalWorkTime
      })

      let hours = totalMinutes / 60 // Stunden berechnen

      let formattedTime = parseFloat(hours.toFixed(2))

      return { formattedTime, totalMinutes }
    },
  },
  methods: {
    async generateAndDownloadExcel() {
      this.exportingExcel = true
      try {
        let current = this.$moment(this.exportStartMonth, "YYYY-MM").startOf("month")
        let end = this.$moment(this.exportEndMonth, "YYYY-MM").endOf("month")

        let payload = {
          employeeName: this.timeEntryView.fullName,
          dateRange: `${current.format("MM.YYYY")} - ${end.format("MM.YYYY")}`,
          months: [],
          totalSummary: [],
          allAbsenceRows: [],
        }

        let totalShould = 0
        let totalIs = 0

        while (current.isSameOrBefore(end, "month")) {
          let dateStr = current.format("YYYY-MM-DD")
          let startDate = current.clone().startOf("month").format("YYYY-MM-DD")
          let endDate = current.clone().endOf("month").format("YYYY-MM-DD")
          let range = [startDate, endDate]

          let studioEmps = await api.fetchOfficeTimeEntriesForStudio(range, this.studio)
          let empData = studioEmps.find((e) => e.user === this.timeEntryView.user)

          if (!empData) {
            current.add(1, "month")
            continue
          }

          let monthObj = {
            name: current.format("MMMM YYYY"),
            targetHours: "-",
            workedHours: "-",
            difference: "-",
            attendanceRows: [],
          }

          const parseHours = (val) => {
            if (val === undefined || val === null) return 0
            if (typeof val === "number") return val
            let str = val.toString().toUpperCase().trim()
            let isNeg = str.startsWith("-")
            if (str.includes("H")) {
              let parts = str.split("H")
              let h = Math.abs(parseFloat(parts[0].replace(/[^\d.-]/g, "")) || 0)
              let m = 0
              if (parts[1] && parts[1].includes("M")) {
                m = Math.abs(parseFloat(parts[1].replace(/[^\d.-]/g, "")) || 0)
              }
              let total = h + m / 60
              return isNeg ? -total : total
            }
            return Number(str.replace(/,/g, ".").replace(/[^\d.-]/g, "")) || 0
          }

          let getPensumForMonth = (employee, dateObj) => {
            let targetFormat = dateObj.format("YYYY-MM")
            let studioId = this.studio && this.studio._id ? this.studio._id : this.studio
            let studioEntry = (employee.studio || []).find((s) => s._id && s._id.toString() === (studioId ? studioId.toString() : ""))
            if (!studioEntry && employee.studio && employee.studio.length) {
              studioEntry = employee.studio[0]
            }
            let pensumHistory = (studioEntry && studioEntry.pensumHistory) || []
            if (!pensumHistory.length) return (studioEntry && studioEntry.percentage) || employee.percentage || 100
            let sortedHistory = pensumHistory.slice().sort((a, b) => b.validFrom.localeCompare(a.validFrom))
            let applicable = sortedHistory.find((h) => h.validFrom <= targetFormat)
            return applicable ? applicable.percentage : (studioEntry && studioEntry.percentage) || employee.percentage || 100
          }

          let ttm = empData.timeTrackerMonths ? empData.timeTrackerMonths.find((t) => t.month === current.format("YYYY-MM")) : null
          if (ttm && (ttm.state === "accepted" || ttm.state === "submitted")) {
            let durationParsed = parseHours(ttm.durationInHours)
            let diffParsed = parseHours(ttm.difference)
            let targetParsed = durationParsed - diffParsed

            if (ttm.durationInHours === undefined && ttm.difference === undefined) {
              // Dynamic retroactive computation (DB stripped data previously)
              let currentMonthPercentage = getPensumForMonth(empData, current)
              let businessDays = 0
              let mDate = current.clone().startOf("month")
              let entryDate = empData.entryDate ? this.$moment(empData.entryDate) : null
              let exitDate = empData.exitDate ? this.$moment(empData.exitDate) : null

              while (mDate.isSameOrBefore(current.clone().endOf("month"), "day")) {
                let isAfterEntry = !entryDate || mDate.isSameOrAfter(entryDate, "day")
                let isBeforeExit = !exitDate || mDate.isSameOrBefore(exitDate, "day")
                if (mDate.day() !== 0 && mDate.day() !== 6 && isAfterEntry && isBeforeExit) {
                  businessDays++
                }
                mDate.add(1, "day")
              }

              let holidayCount = 0
              let studioId = this.studio && this.studio._id ? this.studio._id : this.studio
              let fullStudio = this.storeStudios.find((std) => std._id === studioId)
              let holidayCode = fullStudio ? fullStudio.holidayCode : null

              if (this.holidaysData && this.holidaysData.length) {
                holidayCount = this.holidaysData.filter((h) => {
                  let start = h.startDate && h.startDate.$date ? h.startDate.$date : h.startDate
                  if (!start) return false
                  let hDate = this.$moment(start, "YYYY-MM-DD")
                  if (hDate.format("YYYY-MM") !== current.format("YYYY-MM")) return false

                  if (entryDate && hDate.isBefore(entryDate, "day")) return false
                  if (exitDate && hDate.isAfter(exitDate, "day")) return false
                  if (hDate.day() === 0 || hDate.day() === 6) return false

                  if (h.nationwide) return true
                  if (holidayCode && h.type === "Public" && h.cantons && h.cantons.some((c) => holidayCode.startsWith(c))) {
                    return true
                  }
                  return false
                }).length
              }

              targetParsed = Math.round((businessDays - holidayCount) * ((8.4 * currentMonthPercentage) / 100) * 1000) / 1000

              let totalWorkedMins = 0
              if (empData.attendance) {
                Object.keys(empData.attendance)
                  .filter((d) => d.startsWith(current.format("YYYY-MM")))
                  .forEach((dateStr) => {
                    let timeEntries = empData.attendance[dateStr] || []
                    let inWork = false
                    let lastWorkStart = null

                    let sickMins = 0
                    timeEntries
                      .filter((e) => e.type === "sick")
                      .forEach((e) => {
                        if (e.hours) sickMins += e.hours * 60
                      })
                    totalWorkedMins += sickMins

                    let holEntry = timeEntries.find((e) => e.type === "holiday")
                    if (holEntry && holEntry.hours) totalWorkedMins += holEntry.hours * 60

                    timeEntries.forEach((entry, index) => {
                      if (entry.correction === "open" && !entry.beforeCorrectionTime) return
                      if (entry.type === "checkout" || entry.type === "pause") {
                        if (inWork) {
                          inWork = false
                          totalWorkedMins += this.$moment(dateStr + " " + entry.time).diff(lastWorkStart, "minutes")
                        } else if (index === 0) {
                          inWork = true
                          lastWorkStart = this.$moment(dateStr).startOf("day")
                          totalWorkedMins += this.$moment(dateStr + " " + entry.time).diff(lastWorkStart, "minutes")
                        }
                      } else if (entry.type === "checkin" || entry.type === "pauseend") {
                        if (!inWork) {
                          inWork = true
                          lastWorkStart = this.$moment(dateStr + " " + entry.time)
                        }
                      }

                      if (index === timeEntries.length - 1 && (entry.type === "checkin" || entry.type === "pauseend")) {
                        let startOfDay = this.$moment(dateStr).startOf("day")
                        let isToday = startOfDay.isSame(this.$moment().startOf("day"), "day")
                        if (isToday) {
                          totalWorkedMins += this.$moment().diff(lastWorkStart, "minutes")
                        } else {
                          totalWorkedMins += this.$moment(startOfDay).endOf("day").diff(lastWorkStart, "minutes")
                        }
                      }
                    })
                  })
              }
              durationParsed = totalWorkedMins / 60
              diffParsed = durationParsed - targetParsed

              monthObj.targetHours = targetParsed.toFixed(2) + " h"
              monthObj.workedHours = durationParsed.toFixed(2) + " h"
              monthObj.difference = diffParsed.toFixed(2) + " h"

              if (entryDate && entryDate.isAfter(current.clone().startOf("month"))) {
                monthObj.partialNote = `Reduziert (Eintritt am ${entryDate.format("DD.MM.YYYY")})`
              } else if (exitDate && exitDate.isBefore(current.clone().endOf("month"))) {
                monthObj.partialNote = `Reduziert (Austritt am ${exitDate.format("DD.MM.YYYY")})`
              }
            } else {
              monthObj.targetHours = targetParsed.toFixed(2) + " h"
              monthObj.workedHours = durationParsed.toFixed(2) + " h"
              monthObj.difference = diffParsed.toFixed(2) + " h"
            }
            totalShould += targetParsed
            totalIs += durationParsed
          } else {
            let currentMonthPercentage = getPensumForMonth(empData, current)
            let businessDays = 0
            let day = current.clone().startOf("month")
            let entryDate = empData.entryDate ? this.$moment(empData.entryDate) : null
            let exitDate = empData.exitDate ? this.$moment(empData.exitDate) : null
            while (day.isSameOrBefore(current.clone().endOf("month"), "day")) {
              let isAfterEntry = !entryDate || day.isSameOrAfter(entryDate, "day")
              let isBeforeExit = !exitDate || day.isSameOrBefore(exitDate, "day")
              if (day.day() !== 0 && day.day() !== 6 && isAfterEntry && isBeforeExit) {
                businessDays++
              }
              day.add(1, "day")
            }
            let approxTarget = Math.round(businessDays * ((8.4 * currentMonthPercentage) / 100) * 1000) / 1000

            monthObj.workedHours = "Nicht abgeschlossen"
            monthObj.targetHours = approxTarget.toFixed(2) + " h (Richtwert ohne Feiertage)"
            totalShould += approxTarget
          }

          if (empData.attendance) {
            let sortedDates = Object.keys(empData.attendance).sort()
            for (let d of sortedDates) {
              let timesStr = ""
              let firstType = "Anwesenheit"
              let lastNote = ""

              for (let att of empData.attendance[d]) {
                if (att.correction === "Versteckt" || att.delete || att.disableCorrection) continue
                let actionText = this.mappedEntryTypes[att.type] || att.type
                if (att.absenceReason) actionText = this.mappedEntryTypes[att.absenceReason] || att.absenceReason
                let noteText = att.note || ""
                if (noteText && !lastNote.includes(noteText)) lastNote += noteText + " "

                if (att.type === "checkin" || att.type === "pauseend") {
                  timesStr += att.time + " - "
                } else if (att.type === "checkout" || att.type === "pause") {
                  timesStr += att.time + " | "
                } else {
                  timesStr += `[${actionText} ${att.time || ""}] `
                  if (firstType === "Anwesenheit") firstType = actionText
                }

                if (
                  att.type === "sick" ||
                  att.type === "holiday" ||
                  actionText === "Andere" ||
                  actionText === "Militär" ||
                  actionText === "Schule" ||
                  actionText === "Schwangerschaft"
                ) {
                  payload.allAbsenceRows.push([current.format("MMMM YYYY"), this.$moment(d).format("DD.MM.YYYY"), actionText, noteText])
                }
              }

              if (timesStr) {
                timesStr = timesStr.replace(/(- |\| )$/, "").trim()
                monthObj.attendanceRows.push([
                  this.$moment(d).format("dddd"),
                  this.$moment(d).format("DD.MM.YYYY"),
                  firstType,
                  timesStr,
                  lastNote.trim(),
                ])
              }
            }
          }
          payload.months.push(monthObj)
          current.add(1, "month")
        }

        payload.totalSummary.push(["Total Sollstunden:", totalShould.toFixed(2) + " h", "Erfordert abgeschlossene/eingereichte Monate"])
        payload.totalSummary.push(["Total Iststunden:", totalIs.toFixed(2) + " h", "Erfordert abgeschlossene/eingereichte Monate"])
        payload.totalSummary.push(["Total Differenz:", (totalIs - totalShould).toFixed(2) + " h", "Ist minus Soll"])

        // Trigger export
        import("file-saver").then(async ({ saveAs }) => {
          let blob = await api.exportEmployeeExcel(payload)
          saveAs(blob, `Abrechnung_${this.timeEntryView.fullName}_${this.exportStartMonth}_bis_${this.exportEndMonth}.xlsx`)
          this.exportExcelDialog = false
        })
      } catch (e) {
        console.error(e)
        this.$toast.error("Fehler beim Exportieren")
      } finally {
        this.exportingExcel = false
      }
    },
    async exportToExcel() {
      this.$toast.info("Excel wird erstellt...")
      const data = []
      const attendance = this.timeEntryView.attendance

      // Kopfzeile
      data.push(["Datum", "Firma", "Typ", "Uhrzeit", "Kommentar"])

      const sortedDays = Object.keys(attendance).sort()

      sortedDays.forEach((day) => {
        // FILTER: Badge-Einträge (technicCheckin/technicCheckout) ausschließen
        const relevantEntries = attendance[day].filter((entry) => entry.type !== "technicCheckin" && entry.type !== "technicCheckout")

        relevantEntries.forEach((entry) => {
          data.push([
            this.$moment(day).format("DD.MM.YYYY"),
            entry.company || "Firma 1",
            this.mappedEntryTypes[entry.type] || entry.type,
            entry.time,
            entry.reason || "",
          ])
        })
        if (relevantEntries.length > 0) data.push([])
      })

      data.push(["ZUSAMMENFASSUNG"])
      const statsF1 = this.calculateStatsForCompany("Firma 1")
      const statsF2 = this.calculateStatsForCompany("Firma 2")

      data.push(["Total Firma 1", statsF1.formattedTime + " h"])
      data.push(["Total Firma 2", statsF2.formattedTime + " h"])
      data.push(["Gesamtstunden", ((statsF1.totalMinutes + statsF2.totalMinutes) / 60).toFixed(2) + " h"])

      let csvContent = "data:text/csv;charset=utf-8," + data.map((e) => e.join(";")).join("\n")

      const encodedUri = encodeURI(csvContent)
      const link = document.createElement("a")
      link.setAttribute("href", encodedUri)
      link.setAttribute("download", `Abrechnung_${this.timeEntryView.fullName}_${this.$moment(this.month).format("YYYY-MM")}.csv`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    calculateStatsForCompany(companyName) {
      let totalMinutes = 0
      const attendance = this.timeEntryView.attendance

      Object.keys(attendance).forEach((day) => {
        // Auch hier die Badge-Einträge für die Summenbildung ignorieren
        const dayEntries = attendance[day].filter(
          (e) => (e.company || "Firma 1") === companyName && e.type !== "technicCheckin" && e.type !== "technicCheckout",
        )

        let lastIn = null
        dayEntries.forEach((entry) => {
          if (entry.type === "checkin" || entry.type === "pauseend") {
            lastIn = this.$moment(day + " " + entry.time)
          } else if ((entry.type === "checkout" || entry.type === "pause") && lastIn) {
            totalMinutes += this.$moment(day + " " + entry.time).diff(lastIn, "minutes")
            lastIn = null
          }
        })
      })

      return {
        totalMinutes,
        formattedTime: (totalMinutes / 60).toFixed(2),
      }
    },
    async updateNote() {
      await api.submitTimeTrackerMonth({
        _id: this.timeEntryView.user,
        month: this.month,
        note: this.timeTrackerMonth.note,
        state: "onlyNotes",
      })
      this.$toast.success("Notiz wurde gespeichert")
    },
    async saveSelfCheckinEntryEdit() {
      let updated = await api.saveSelfCheckinEntryEditTODB({
        item: this.selfCheckinEntryEdit,
        user: this.timeEntryView,
      })
      this.selfCheckinEntryEdit = null
      this.changeCanSelfCheckinNoAdminDialog = false
      this.$toast.success("Änderung wurde gespeichert")
    },
    changeCanSelfCheckinNoAdmin(item, newEntry = false) {
      if (newEntry) {
        console.log(item)
        this.selfCheckinEntryEdit = {
          type: "",
          time: "",
          realDate: item.realDate,
        }
      } else {
        this.selfCheckinEntryEdit = item
        this.selfCheckinEntryEdit.preservedTime = JSON.parse(JSON.stringify(item.time))
      }
      this.changeCanSelfCheckinNoAdminDialog = true
    },
    hasCorrectionsOpenAlert() {
      alert("Es sind noch Korrekturen offen")
    },
    async fixToShortTime(item, option) {
      let attendances = this.timeEntryView.attendance[item.realDate]
        .filter((att) => !att.type.includes("error"))
        .map((x) => {
          return {
            time: x.time,
            oldType: x.oldType,
            type: x.type,
            autoFixedTime: x.time,
            studio: x.studio,
          }
        })
      let totalWorkTime = 0
      let totalBreakTime = 0
      let breakPairs = []

      for (let i = 0; i < attendances.length - 1; ) {
        if (attendances[i].oldType === "checkin" && attendances[i + 1].oldType === "checkout") {
          let checkinTime = this.$moment(attendances[i].time, "HH:mm:ss")
          let checkoutTime = this.$moment(attendances[i + 1].time, "HH:mm:ss")

          totalWorkTime += checkoutTime.diff(checkinTime, "minutes")
          i += 2

          if (i < attendances.length - 1 && attendances[i].oldType === "checkin") {
            let nextCheckinTime = this.$moment(attendances[i].time, "HH:mm:ss")
            let breakTime = nextCheckinTime.diff(checkoutTime, "minutes")
            totalBreakTime += breakTime
            breakPairs.push({ start: checkoutTime, end: nextCheckinTime, duration: breakTime })
          }
        } else {
          i++
        }
      }

      let requiredBreak = this.getRequiredBreak(totalWorkTime)
      console.log(requiredBreak, "requiredBreak")
      if (attendances.length == 2) {
        let checkinTime = this.$moment(attendances[0].time, "HH:mm:ss")
        let checkoutTime = this.$moment(attendances[1].time, "HH:mm:ss")
        let subtractTime = requiredBreak / 2
        let middleTime = this.$moment(JSON.parse(JSON.stringify(checkoutTime)))
        checkoutTime.add(requiredBreak / 2, "minutes")
        attendances[1].time = checkoutTime.format("HH:mm:ss")
        attendances.splice(
          1,
          0,
          {
            time: this.$moment(JSON.parse(JSON.stringify(middleTime)))
              .subtract(requiredBreak / 2, "minutes")
              .format("HH:mm:ss"),
            type: "pause",
            oldType: "checkout",
          },
          {
            time: middleTime.format("HH:mm:ss"),
            type: "pauseend",
            oldType: "checkin",
          },
        )

        breakPairs.push({
          start: this.$moment(JSON.parse(JSON.stringify(middleTime))).subtract(requiredBreak / 2, "minutes"),
          end: this.$moment(JSON.parse(JSON.stringify(middleTime))),
          duration: requiredBreak / 2,
        })
        totalBreakTime += requiredBreak / 2
      }

      if (totalBreakTime < requiredBreak) {
        let diff = requiredBreak - totalBreakTime

        if (option === "extendPause") {
          if (breakPairs.length > 0) {
            let lastBreak = breakPairs[breakPairs.length - 1]
            if (lastBreak) {
              lastBreak.end.add(diff, "minutes")
              lastBreak.duration += diff
            }
          }
        } else if (option === "extendWorktime") {
          if (breakPairs.length > 0) {
            let lastBreak = breakPairs[breakPairs.length - 1]
            if (lastBreak) {
              lastBreak.end.add(diff, "minutes")
              lastBreak.duration += diff
            }

            let lastCheckout = attendances.find((att) => att.oldType === "checkout" && this.$moment(att.time, "HH:mm:ss").isAfter(lastBreak.end))
            let lastCheckoutIndex = attendances.findIndex(
              (att) => att.oldType === "checkout" && this.$moment(att.time, "HH:mm:ss").isAfter(lastBreak.end),
            )

            if (lastCheckout) {
              let lastCheckoutTime = this.$moment(lastCheckout.time, "HH:mm:ss")
              lastCheckoutTime.add(diff, "minutes")
              attendances[lastCheckoutIndex].time = lastCheckoutTime.format("HH:mm:ss")
            } else {
              let lastCheckout = attendances[attendances.length - 1]
              if (lastCheckout.oldType === "checkout") {
                let lastCheckoutTime = this.$moment(lastCheckout.time, "HH:mm:ss")
                lastCheckoutTime.add(diff, "minutes")
                lastCheckout.time = lastCheckoutTime.format("HH:mm:ss")
              }
            }
          }
        }
        for (let i = 0; i < attendances.length - 1; i++) {
          if (attendances[i].oldType === "checkout" && attendances[i + 1].oldType === "checkin") {
            let breakPair = breakPairs.shift()
            if (breakPair) {
              attendances[i].time = breakPair.start.format("HH:mm:ss")
              attendances[i + 1].time = breakPair.end.format("HH:mm:ss")
            }
          }
        }
      }
      this.preSavedAttendances = {
        new: attendances,
        old: this.timeEntryView.attendance[item.realDate],
        date: item.realDate,
      }
      this.fixTimeDialog = true
    },
    getRequiredBreak(workDuration) {
      if (workDuration <= 330) {
        return 0
      } else if (workDuration < 420) {
        return 15
      } else if (workDuration < 540) {
        return 30
      } else {
        return 60
      }
    },
    async savePreSavedAttendances() {
      this.timeEntryView.attendance[this.preSavedAttendances.date] = this.preSavedAttendances.new
      await api.savePreSavedAttendancesToDB(this.preSavedAttendances, this.timeEntryView.user)

      this.fixTimeDialog = false
      this.preSavedAttendances = null
      this.fixTimeDialogOptionPicker = false
    },
    async deleteSickEntry(item) {
      if (confirm("Willst du den Eintrag wirklich löschen?")) {
        await api.deleteSickEntry(item)
        if (this.reloadAfterChanges) {
          this.$emit("fetchEntries")
        } else {
          this.$toast.warning("Neuladen um Anzeigefehler zu vermeiden.")
        }
      }
    },
    submitTimeTrackerMonth(state = "submitted") {
      let validation = true
      let tableItem = null
      let overTime = this.timeEntryView.overTime || 0

      // Validierung (bleibt gleich)
      this.tableItems.forEach((item) => {
        if (validation) {
          validation = this.checkToShortPause(item)
          if (!validation) tableItem = item
        }
      })
      if (!validation) return alert("Bitte prüfe die Pausenzeit vom " + this.$moment(tableItem.realDate, "YYYY-MM-DD").format("DD. MMMM ") + "")

      // Berechnungen für den Dialog
      let difference = 0
      let formattedDuration = this.getTotalDuration.formattedTime

      if (this.currentMonthPercentage) {
        difference =
          Math.round(
            (formattedDuration -
              (this.calcBusinessDays - this.vacationDaysForMonth(this.studio).length) * ((8.4 * this.currentMonthPercentage) / 100)) *
              1000,
          ) / 1000
      }

      // Daten in State speichern
      this.submitOfficeData = {
        duration: formattedDuration,
        difference: difference,
        percentage: this.currentMonthPercentage,
        overtimeBefore: overTime,
        newOvertime: Math.round((overTime + difference) * 100) / 100,
        targetState: state,
      }

      // Wenn es ein einfacher Submit (z.B. Mitarbeiter selbst) ist ohne spezielle Berechnungen,
      // oder wenn es nur um Notizen geht, nutzen wir den alten Weg (optional, oder immer Dialog).
      // Hier triggern wir den neuen Dialog für den Vorgesetzten-Kontext:
      this.showSubmitOfficeDialog = true
    },

    // 2. Die eigentliche Ausführung nach Klick im Dialog
    async confirmOfficeSubmission() {
      this.submitLoading = true
      try {
        let state = this.submitOfficeData.targetState

        // Submission State Objekt vorbereiten (falls "accepted")
        if (state === "accepted") {
          this.submissionState.overTimeBefore = this.submitOfficeData.overtimeBefore
          this.submissionState.overTimeAfter = this.submitOfficeData.newOvertime
          this.submissionState.percentage = this.submitOfficeData.percentage
          this.submissionState.durationInHours = this.submitOfficeData.duration
          this.submissionState.difference = this.submitOfficeData.difference
        }

        // API Call
        if (this.submissionState) {
          await api.updateTimeTrackerMonth({
            _id: this.timeEntryView.user,
            submissionState: this.submissionState,
            state,
          })
        } else {
          await api.submitTimeTrackerMonth({
            _id: this.timeEntryView.user,
            month: this.month,
            note: this.timeTrackerMonth.note,
          })
        }

        // Cleanup
        this.showSubmitOfficeDialog = false

        if (this.reloadAfterChanges) {
          this.$emit("fetchEntries")
        } else {
          this.$toast.warning("Neuladen um Anzeigefehler zu vermeiden.")
        }
        this.$toast.success("Erfolgreich gespeichert")
      } catch (e) {
        console.error(e)
        this.$toast.error("Fehler beim Speichern")
      } finally {
        this.submitLoading = false
      }
    },
    getAbsenceDuration(attendanceItem) {
      let sickDuration = 0
      let holidayDuration = 0
      let notes = []

      attendanceItem.forEach((entry) => {
        if (entry.type === "sick") {
          sickDuration += (entry.hours || 0) * 60
          if (entry.note) notes.push(entry.note)
        } else if (entry.type === "holiday") {
          holidayDuration += (entry.hours || 0) * 60
          if (entry.note) notes.push(entry.note)
        }
      })

      return {
        formattedTime:
          sickDuration + holidayDuration > 0 ? this.$moment.utc((sickDuration + holidayDuration) * 60 * 1000).format("HH[H] mm[M]") : "-",
        note: notes.join(", "),
      }
    },
    vacationDaysForMonth(studio) {
      if (studio._id) studio = studio._id
      let fullStudio = this.storeStudios.find((std) => std._id === studio)
      let holidayCode = fullStudio ? fullStudio.holidayCode : null
      let monthFormat = this.$moment(this.month).format("YYYY-MM")

      let matchedHolidays = this.holidaysData.filter((holiday) => {
        let start = holiday.startDate && holiday.startDate.$date ? holiday.startDate.$date : holiday.startDate
        if (!start) return false

        if (this.$moment(start).format("YYYY-MM") !== monthFormat) return false

        let holidayDate = this.$moment(start, "YYYY-MM-DD")
        let entryDate = this.timeEntryView.entryDate ? this.$moment(this.timeEntryView.entryDate, "YYYY-MM-DD") : null
        let exitDate = this.timeEntryView.exitDate ? this.$moment(this.timeEntryView.exitDate, "YYYY-MM-DD") : null

        if (entryDate && holidayDate.isBefore(entryDate, "day")) return false
        if (exitDate && holidayDate.isAfter(exitDate, "day")) return false

        if (holiday.nationwide) return true
        if (holidayCode && holiday.type === "Public" && holiday.cantons && holiday.cantons.some((c) => holidayCode.startsWith(c))) {
          return true
        }
        return false
      })

      return matchedHolidays.map((hol) => ({
        title: hol.name,
        date: hol.startDate && hol.startDate.$date ? hol.startDate.$date : hol.startDate,
      }))
    },
    async acceptCorrection(correctedItem) {
      correctedItem.user = this.timeEntryView.user
      let correction = await api.acceptAttendanceCorrection(correctedItem)
      if (this.reloadAfterChanges) {
        this.$emit("fetchEntries")
      } else {
        this.$toast.warning("Neuladen um Anzeigefehler zu vermeiden.")
      }
    },
    async rejectCorrection(correctedItem) {
      correctedItem.user = this.timeEntryView.user
      let correction = await api.rejectAttendanceCorrection(correctedItem)
      if (this.reloadAfterChanges) {
        this.$emit("fetchEntries")
      } else {
        this.$toast.warning("Neuladen um Anzeigefehler zu vermeiden.")
      }
    },
    checkToShortPause(item) {
      let workedMinutes = this.getWorkDuration(item.realDate, item.disableCorrection, true).minutes
      let pauseDuration = this.getPauseDuration(item.realDate, item.disableCorrection).minutes
      if (workedMinutes > 330 && workedMinutes < 470) {
        return pauseDuration >= 15
      } else if (workedMinutes >= 470 && workedMinutes < 540) {
        return pauseDuration >= 30
      } else if (workedMinutes >= 540) {
        return pauseDuration >= 60
      } else {
        return true
      }
    },
    updateIt() {
      this.keyey++
    },
    showEmployeeCorretionDialog(item) {
      this.showCorrectionDialog = true
      this.correctedItem = item
    },
    tableItemsForItem(realDate, disableCorrection = false) {
      return this.timeEntryView.attendance[realDate].map((item) => {
        let correctionReason = "-"
        if (item.correction) {
          if (item.beforeCorrectionTime) {
            correctionReason = "Bearbeitet"
          } else if (item.delete) {
            correctionReason = "Gelöscht"
          } else {
            correctionReason = "Neu"
          }
          if (item.deleted) {
            correctionReason = "Gelöscht"
          }
          if (disableCorrection) {
            correctionReason = "Versteckt"
          }

          if (item.correction === "approved") {
            correctionReason = "Akzeptiert"
          }

          if (item.correction === "rejected") {
            correctionReason = "Abgelehnt"
          }
        }
        return {
          absenceReason: item.absenceReason,
          sickEntryID: item.sickEntryID,
          date: realDate,
          correctedTo: item.correctedTo,
          beforeCorrectionTime: item.beforeCorrectionTime,
          beforeCorrectedTime: item.beforeCorrectedTime,
          beforeCorrectedType: item.beforeCorrectedType,
          beforeCorrectionType: item.beforeCorrectionType,
          delete: item.delete,
          time:
            item.time === "23:59:59"
              ? "-"
              : disableCorrection && item.correction && item.correction === "open"
              ? item.beforeCorrectionTime || "-"
              : item.time,
          type: disableCorrection ? item.beforeCorrectionType || item.correctedType || item.type : item.correctedType || item.type,
          studio:
            item.studio && this.storeStudios.find((studio) => studio._id === item.studio)
              ? this.storeStudios.find((studio) => studio._id === item.studio).name
              : "-",
          status: item.status ? this.mapHolidayStatus[item.status] : "-",
          correction: correctionReason,
          duration: item.hours ? item.hours + " Stunden" : "-",
        }
      })
    },
    /*  async deleteSickEntry(id) {
            if (confirm('Krankheitseintrag wirklich löschen?')) {
                try {
                    let status = await api.deleteSickEntryManagement(id)
                    this.$emit('fetchEntries')
                    this.$toast.success('Krankheitseintrag gelöscht')
                } catch (e) {
                    this.$toast.error('Es gab einen Fehler beim löschen des Krankheitseintrags')
                }
            }
        }, */
    async changeHolidayStatus(holidayEntry, status) {
      if (status) {
        try {
          let status = await api.changeHolidayStatus({ _id: holidayEntry._id, status: "accepted" })
          this.$toast.success("Status aktualisiert")
          holidayEntry.status = "accepted"
        } catch (e) {
          this.$toast.error("Es gab einen Fehler beim aktualisieren des Status")
        }
      } else {
        try {
          let status = await api.changeHolidayStatus({ _id: holidayEntry._id, status: "denied" })
          this.$toast.success("Status aktualisiert")
          holidayEntry.status = "denied"
        } catch (e) {
          this.$toast.error("Es gab einen Fehler beim aktualisieren des Status")
        }
      }
    },
    shorten(reason) {
      if (reason && reason.length > 5) {
        return reason.slice(0, 5) + "..."
      } else {
        return "-"
      }
    },
    timeTrackerInfosUpdated(data) {
      if (this.reloadAfterChanges) {
        this.$emit("fetchEntries", data)
      } else {
        this.$toast.warning("Neuladen um Anzeigefehler zu vermeiden.")
      }
    },
    getStartTime(date, disableCorrection) {
      let entries = this.filteredAttendance[date] || []
      let firstWorkEvent = entries.find((e) => e.type === "checkin")
      if (date === "2023-06-16") console.log(firstWorkEvent, firstWorkEvent.correction === "open")
      if (firstWorkEvent)
        return disableCorrection && firstWorkEvent.correction && firstWorkEvent.correction === "open"
          ? firstWorkEvent.beforeCorrectionTime || "-"
          : firstWorkEvent.time
      else return "-"
    },
    getEndTime(date, disableCorrection) {
      let entries = this.filteredAttendance[date] || []
      let lastWorkEvent = entries
        .slice()
        .reverse()
        .find((e) => e.type === "checkout")
      if (lastWorkEvent)
        return disableCorrection && lastWorkEvent.correction && lastWorkEvent.correction === "open"
          ? lastWorkEvent.beforeCorrectionTime || "-"
          : lastWorkEvent.time
      else return "-"
    },
    getHolidayDuration(timeEntries) {
      if (!timeEntries.length)
        return {
          formattedTime: "-",
          minutes: 0,
        }
      return timeEntries.find((e) => e.type === "holiday")
        ? {
            formattedTime: this.$moment.utc(timeEntries.find((e) => e.type === "holiday").hours * 60 * 60 * 1000).format("HH[H] mm[M]"),
            minutes: timeEntries.find((e) => e.type === "holiday").hours * 60,
          }
        : {
            formattedTime: "-",
            minutes: 0,
          }
    },
    getSickDuration(timeEntries) {
      if (!timeEntries.length)
        return {
          formattedTime: "-",
          minutes: 0,
        }
      let filteredEntries = timeEntries.filter((e) => e.type === "sick")
      if (!filteredEntries.length)
        return {
          formattedTime: "-",
          minutes: 0,
        }

      let countMinutes = 0

      timeEntries.forEach((entry) => {
        if (entry.hours) {
          countMinutes += entry.hours * 60
        }
      })

      return {
        formattedTime: this.$moment.utc(countMinutes * 60 * 1000).format("HH[H] mm[M]"),
        minutes: countMinutes,
      }
    },
    getPauseDuration(date, disableCorrection) {
      let timeEntries = this.filteredAttendance[date] || []

      let totalPauseTime = 0
      let inPause = false
      let lastPauseStart = null
      let startetPauseFirstTime = false

      timeEntries.forEach((entry, index) => {
        if (entry.type === "pause") entry.oldType = "checkout"
        if (entry.type === "pauseend") entry.oldType = "checkin"

        if (disableCorrection && entry.correction && entry.correction === "open" && !entry.beforeCorrectionTime) {
          return
        }

        if (entry.type.includes("error") || (entry.correction === "rejected" && entry.correction.newEntry)) {
          return
        }
        if (entry.oldType === "checkout" && !inPause) {
          startetPauseFirstTime = true
          inPause = true
          lastPauseStart = entry.time
        } else if (inPause && entry.oldType === "checkin" && startetPauseFirstTime) {
          inPause = false
          totalPauseTime += this.$moment(entry.time, "HH:mm:ss").diff(this.$moment(lastPauseStart, "HH:mm:ss"), "minutes")
        }
      })
      let hours = Math.floor(totalPauseTime / 60) // Stunden berechnen
      let minutes = totalPauseTime % 60 // Minuten berechnen
      let formattedTime = hours !== 0 || minutes !== 0 ? hours.toString().padStart(2, "0") + "H " + minutes.toString().padStart(2, "0") + "M" : "-"
      return { formattedTime, totalPauseTime, minutes: minutes + hours * 60 }
    },

    getWorkDuration(date, disableCorrection, ignoreSickDuration = false) {
      let timeEntries = this.filteredAttendance[date] || []
      let inWork = false
      let lastWorkStart = null
      let totalWorkTime = 0
      if (!ignoreSickDuration) {
        totalWorkTime = this.getSickDuration(timeEntries).minutes || 0
        totalWorkTime += this.getHolidayDuration(timeEntries).minutes || 0
      }
      timeEntries.forEach((entry, index) => {
        if (disableCorrection && entry.correction && entry.correction === "open" && !entry.beforeCorrectionTime) return
        if (entry.type === "checkout" || entry.type === "pause") {
          if (inWork) {
            inWork = false
            totalWorkTime += this.$moment(
              date + " " + (disableCorrection && entry.correction && entry.correction === "open" ? entry.beforeCorrectionTime || "" : entry.time),
            ).diff(lastWorkStart, "minutes")
          } else if (index === 0) {
            // assume a pause starting at 00:00 for first entry of type "pauseend"
            inWork = true
            lastWorkStart = this.$moment(date).startOf("day")
            totalWorkTime += this.$moment(
              date +
                " " +
                (disableCorrection && entry.correction && entry.correction !== "appproved" ? entry.beforeCorrectionTime || "" : entry.time),
            ).diff(lastWorkStart, "minutes")
          }
        } else if (entry.type === "checkin" || entry.type === "pauseend") {
          if (!inWork) {
            inWork = true
            lastWorkStart = this.$moment(
              date + " " + (disableCorrection && entry.correction && entry.correction === "open" ? entry.beforeCorrectionTime || "" : entry.time),
            )
          }
        }

        if (index === timeEntries.length - 1 && (entry.type === "checkin" || entry.type === "pauseend")) {
          let startOfDay = this.$moment(date).startOf("day")
          let isToday = startOfDay.isSame(this.$moment().startOf("day"), "day")

          if (isToday) {
            const time = this.$moment()
            totalWorkTime += time.diff(lastWorkStart, "minutes")
          } else {
            const endOfDay = this.$moment(startOfDay).endOf("day")
            totalWorkTime += endOfDay.diff(lastWorkStart, "minutes")
          }
        }
      })
      let hours = Math.floor(totalWorkTime / 60) // Stunden berechnen
      let minutes = Math.floor(totalWorkTime % 60) // Minuten berechnen

      let formattedTime = hours.toString().padStart(2, "0") + "H " + minutes.toString().padStart(2, "0") + "M"
      return { formattedTime, totalWorkTime, minutes: minutes + hours * 60 }
    },
    getDurationForDay(date, disableCorrection) {
      let timeEntries = this.timeEntryView.attendance[date]
      let totalWorkTime = this.getWorkDuration(date, disableCorrection).totalWorkTime
      let totalPauseTime = this.getPauseDuration(date, disableCorrection).totalPauseTime
      let durationTimeInMinutes = totalWorkTime + totalPauseTime
      let hours = Math.floor(durationTimeInMinutes / 60) // Stunden berechnen
      let minutes = Math.floor(durationTimeInMinutes % 60) // Minuten berechnen
      let formattedTime = hours.toString().padStart(2, "0") + "H " + minutes.toString().padStart(2, "0") + "M"
      return { formattedTime, durationTimeInMinutes }
    },
    getDuration(date, disableCorrection) {
      let timeEntries = this.timeEntryView.attendance[date]
      let totalWorkTime = this.getWorkDuration(date, disableCorrection).totalWorkTime
      let totalPauseTime = this.getPauseDuration(date, disableCorrection).totalPauseTime
      let durationTimeInMinutes = totalWorkTime - totalPauseTime
      let hours = Math.floor(durationTimeInMinutes / 60) // Stunden berechnen
      let minutes = durationTimeInMinutes % 60 // Minuten berechnen

      let formattedTime = hours.toString().padStart(2, "0") + "H " + minutes.toString().padStart(2, "0") + "M"
      return { formattedTime, durationTimeInMinutes }
    },
  },
}
</script>

<style lang="scss" scoped>
.glass-card {
  background: #1e1e1e; /* Fallback */
  background: rgba(30, 30, 30, 0.95);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.icon-ring {
  border: 6px solid #1e1e1e; /* Sollte matchen mit Dialog Overlay oder Hintergrund */
}
.shadow-glow {
  box-shadow: 0 0 20px rgba(0, 150, 63, 0.4) !important;
}
.border-light {
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.overflow-visible {
  overflow: visible !important;
}
.btn-hover-scale:hover {
  transform: scale(1.02);
  transition: transform 0.2s;
}
</style>
